import { useEffect } from 'react';

export default function useScrollPosition(onScroll, deps) {
  const doScroll = () => {
    const { scrollX, scrollY } = window;
    onScroll({ scrollX, scrollY });
  };
  useEffect(() => {
    if (!document || typeof document === 'undefined') return null;

    doScroll();
    window.addEventListener('scroll', doScroll);
    return () => window.removeEventListener('scroll', doScroll);
  }, deps);
}
